import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { OrientatedUserLocationMarker } from 'shared/map/ui/components/marker/rotated/ui';
import { setMapCenterAndZoom } from 'shared/map/model/slice';
import { useAppActive } from 'shared/map/ui/components/marker/rotated/lib/app-active';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
export const useUserLocationMarker = (device_id) => {
    const show_geolocation = useAppSelector((state) => select_ui_settings(state).map?.show_geolocation ?? true);
    const ref = useRef(null);
    const onWantMapCenter = useAction(setMapCenterAndZoom);
    const onCenterOnUser = useCallback(() => {
        if (ref.current != null) {
            onWantMapCenter({ center: ref.current, zoom: 15, device_id });
        }
    }, [device_id]);
    const onSuccess = useCallback((position) => {
        if (position) {
            ref.current = [position.longitude, position.latitude];
        }
    }, []);
    const UserLocationMarker = useCallback(() => {
        const isAppActive = useAppActive(1e4);
        if (!show_geolocation) {
            return null;
        }
        //Если неактивно приложение, то не пытаемся спрашивать местоположение пользователя
        if (!isAppActive) {
            return null;
        }
        return _jsx(OrientatedUserLocationMarker, { onSuccess: onSuccess });
    }, [show_geolocation, onSuccess]);
    return [UserLocationMarker, onCenterOnUser, ref.current];
};
